import React, {
  ComponentPropsWithoutRef,
  ElementType,
  useCallback,
  useRef,
} from 'react';
import classnames from 'classnames';

import './Overlay.scss';

const positionOptions = ['top', 'center', 'bottom'] as const;
export type PositionOption = (typeof positionOptions)[number];

export interface OverlayProps extends ComponentPropsWithoutRef<ElementType> {
  className?: string;
  position?: PositionOption;
  dark?: boolean;
  actionable?: boolean;
  onOverlayClick?: (e) => void;
  children: React.ReactNode;
}

const Overlay = ({
  className,
  position = 'center',
  dark,
  actionable,
  onOverlayClick: onClick,
  children,
  ...props
}: OverlayProps) => {
  const overlayRef = useRef<HTMLDivElement>(null);
  const handleClickOverlay = useCallback(
    (event) => {
      if (onClick && event.target === overlayRef.current) {
        onClick(event);
      }
    },
    [onClick],
  );

  return (
    <div
      className={classnames(
        'overlay',
        {
          [`overlay_${position}`]: position,
          overlay_dark: dark,
          overlay_actionable: onClick || actionable,
        },
        className,
      )}
      ref={overlayRef}
      onClick={handleClickOverlay}
      {...props}
    >
      <div className="overlay__content">{children}</div>
    </div>
  );
};

export default Overlay;
